import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AsyncPipe, Location } from '@angular/common';
import { GetDebugImageUrls } from '../../../state/diagnostics/diagnostics.actions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IDiagnosticDebugImageUrl } from '../../../state/interfaces';
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { ThrottleClickDirective } from '@drc-eca/eca-lrc-common-ui';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';


@Component({
  selector: 'eca-scan-debug-images',
  templateUrl: './scan-debug-images.component.html',
  styleUrls: ['./scan-debug-images.component.css'],
  imports: [MatCard, MatCardHeader, MatCardTitle, MatButton, ThrottleClickDirective, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, AsyncPipe]
})
export class ScanDebugImagesComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private location = inject(Location);
  private store = inject<Store<any>>(Store);


  debugUrls$: Observable<IDiagnosticDebugImageUrl[]>;
  scanId: string;

  constructor() {
    this.debugUrls$ = this.store.select('diagnostics', 'debugUrls');
    this.scanId = decodeURIComponent(this.route.snapshot.params.imageId);
  }

  ngOnInit() {
    this.store.dispatch(new GetDebugImageUrls(encodeURIComponent(this.scanId)));
  }

  back() {
    this.location.back();
  }
}
